module.exports = __webpack_public_path__ + "static/beefsirlointips-d2e234da44c450cae87c0011bf359152.jpg";